import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { useTrans } from '@core/Hook/trans';
import DefaultModal, { IDefaultModal } from '../../Component/Modal/DefaultModal';

const CommentCustomTextModalStyled = styled(Box)(({ theme }) => ({
    '&.x-comment-custom-text-container': {
        display: 'flex',
        justifyContent: 'flexStart',
        alignItems: 'flexStart',
        flexDirection: 'column',
        height: '300px',
        whiteSpace: 'break-spaces',
        '.-loader-wrapper': {
            margin: theme.spacing(2, 0),
        },
        '.-description-text': {
            fontSize: theme.baseVariables.fonts.fontSizeSmaller,
        },
    },
}));

const CommentCustomTextModal: React.FC<IDefaultModal> = ({ open, handleClose, data, ...rest }) => {
    const { trans } = useTrans();
    const [title, comments] = data
    if (!open) return <></>;

    return (
        <DefaultModal
            {...rest}
            isHalfSize
            open={open}
            title={trans('order_summary.comment_custom_text_modal.title')}
            titleColor={'primary'}
            handleClose={handleClose}
        >
            <CommentCustomTextModalStyled className={'x-comment-custom-text-container'}>
                {comments.join('\n').split('\n').map((comment: string, index: number) => (
                    <React.Fragment key={index}>
                        <Box className={'-description-text'}>{`${index + 1}. ${comment}`}</Box>
                    </React.Fragment>
                ))}
            </CommentCustomTextModalStyled>
        </DefaultModal>
    );
};

export default CommentCustomTextModal;
